export interface AssessmentGraphData {
  jobs: Array<{
    id: number;
    company_id: number;
    creation_date: Date;
    expiration_date: Date;
    pub_status: boolean;
    title: string;
  }>;
  bars: Array<{
    applications: number;
    name: string;
  }>;
}

export interface ChartOptions {
  scheme: any;
  showLabels: boolean;
  animations: boolean;
  xAxis: boolean;
  yAxis: boolean;
  noBarWhenZero: boolean;
  showDataLabel: boolean;
  roundEdges: boolean;
  barPadding: number;
}

export enum DateRangePreset {
  LAST_7_DAYS = 'last_7_days',
  LAST_30_DAYS = 'last_30_days',
  LAST_90_DAYS = 'last_90_days',
  THIS_MONTH = 'this_month',
  LAST_MONTH = 'last_month',
  YEAR_TO_DATE = 'year_to_date',
  LAST_YEAR = 'last_year',
  ALL_TIME = 'all_time'
}
